import className from '../../common/className.js'
import {sanitize} from '../../common/sanitize.js'
import {
  bannerMessageSelector,
  dismissAppMessage,
  showBannerMessageSelector,
  showUndismissableBannerMessageSelector,
  undismissableBannerMessageSelector,
} from '../../data/appMessage.js'
import {isSuperuserSelector} from '../../data/me.js'
import {useSelector} from '../../store.js'
import Icon from '../../common/icons/Icon.js'

/**
 * A "top of app" message
 *
 * @param {Object} props
 * @param {Boolean} [props.undismissable]
 * @returns {React.ReactNode}
 */
export default function BannerMessage({undismissable}) {
  const bannerMessage = useSelector(
    undismissable ? undismissableBannerMessageSelector : bannerMessageSelector,
  )
  const showBannerMessage = useSelector(
    undismissable
      ? showUndismissableBannerMessageSelector
      : showBannerMessageSelector,
  )
  const isSuperuser = useSelector(isSuperuserSelector)

  if (!showBannerMessage) {
    return null
  }

  const message =
    isSuperuser && bannerMessage.label
      ? `${bannerMessage.message} (${bannerMessage.label})`
      : bannerMessage.message

  return (
    <div
      className={className`full-width wrap--banner-msg ${bannerMessage.meta.className}`}
      style={
        bannerMessage.meta.style && {
          backgroundColor: bannerMessage.meta.style['background-color'],
          color: bannerMessage.meta.style['color'],
        }
      }
    >
      <div
        className="fs-00 lh-md align-center margin-bottom-0"
        dangerouslySetInnerHTML={{
          __html: sanitize(message, {
            allowedAttributes: {'*': ['class', 'style']},
          }),
        }}
      />
      {!bannerMessage.meta.can_not_dismiss && (
        <button
          className="btn btn--link no-underline btn--close-banner-msg"
          onClick={() => dismissAppMessage(bannerMessage.id)}
        >
          <Icon name="times" className="fs-01" />
        </button>
      )}
    </div>
  )
}
